// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"VehicleState_loadingBox__2nb5O","validating":"VehicleState_validating__2SKI0"};